const setTable = function (state, config: any) {
  const { limit, page, query } = config

  state.table = {
    searchText: query,
    currentPage: page,
    totalPages: 0,
    limit: limit,
  }
}

export default setTable
